import React from 'react';
import { IPricingBlockPreviewProps } from './IPricingBlockPreviewProps';
import anchorme from 'anchorme';
import PriceInBlockPreview from './PriceInBlockPreview';
import { ButtonAction, scrollElementIntoView } from 'containers/PageBuilder/SinglePageContainer/domain';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import styled from 'styled-components';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import BlockButton from '../BlockComponents/BlockButton';
import { BlockButtonsContainer, BlockSideButton } from '../ButtonBlockPreview/ButtonBlockPreview';
import miscUtils from 'utils/miscUtils';

const PricingBlockContentContainer: any = styled(BlockContentContainer)`
    align-items: ${(props: any) =>
        props.design.text_alignment === 'right' ? 
        `flex-end`:
        props.design.text_alignment === 'left' ?
        'flex-start' :
        'center'
    };
`;

const PricingBlockPricesContainer: any = styled.div<{props: any}>`
    width: 100%;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: ${(props: any) =>
        props.design.text_alignment === 'right' ? 
        `flex-end`:
        props.design.text_alignment === 'left' ?
        'flex-start' :
        'center'
    };
`;

const PricingBlockPreview: React.FC<IPricingBlockPreviewProps> = (props) => {

    const ctaOnClick = (blockData: any) => {
        if(props.buildingPreview) {
            return;
        }

        if(
            blockData &&
            (
                blockData.button_action === ButtonAction.URL ||
                blockData.button_action === ButtonAction.URLTab
            ) &&
            blockData.button_url
        ) {
            window.open(
                miscUtils.ensureHttps(blockData.button_url), 
                blockData.button_action === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Scroll &&
            blockData.button_url &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${blockData.button_url}`);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Popup &&
            blockData.button_url
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

            nextPageFormsOpenState[blockData.button_url] = true;

            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Page &&
            blockData.button_url
        ) {
            window.open(
                `${blockData.button_url}`,
                '_self'
            );
            return;
        }
    }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <PricingBlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#666666"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.subtext),
          }}
          />

          <PricingBlockPricesContainer
          design={props.blockData.design}
          >
            {props.blockData.blocks.map((block: any, index: number) => (
                <PriceInBlockPreview
                key={block.render_id}
                buildingPreview={props.buildingPreview}
                index={index}
                blockData={{
                    ...block,
                    design: {
                        ...props.blockData.design,
                    }
                }}
                view={props.view}
                pageStyles={props.pageStyles}
                />
            ))}
          </PricingBlockPricesContainer>

            {props.blockData.button_shown ? (
                <BlockButtonsContainer
                className={`${props.view ? props.view : ''}`}
                >
                    <BlockButton
                    design={props.blockData.design}
                    pageStyles={props.pageStyles}
                    onClick={() => ctaOnClick(props.blockData)}
                    >
                        {props.blockData.button_text}
                    </BlockButton>
    
                    {props.blockData.side_by_side_buttons ? (
                        props.blockData.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                            <BlockSideButton
                            key={`${index}`}
                            className={`${props.view ? props.view : ''}`}
                            design={side_by_side_button.design}
                            pageStyles={props.pageStyles}
                            onClick={() => ctaOnClick(side_by_side_button)}
                            >
                                {side_by_side_button.button_text}
                            </BlockSideButton>
                        ))
                    ) : <></>}
                </BlockButtonsContainer>
            ) : <></>}
        </PricingBlockContentContainer>
    </BlockContainer>
  )
}

export default PricingBlockPreview;